import { useLocation } from 'react-router-dom'

import { linkActive, Link } from '../helpers/navStructure'

export default function useIsActivePath(href: string, children: Link[]): boolean {
  const { pathname } = useLocation()
  return linkActive(href, children, pathname)
}
